const clevryURLs = [
  'https://criterion-psycruit-findyourjoy-v1.uat.avamae.co.uk/',
  'https://staging-joy.clevry.com/',
  'https://joy.clevry.com/',
];

export const checkIsClevrySubdomain = (subdomain: string) => {
  return (
    clevryURLs.filter((clevryURL: string) => clevryURL.includes(subdomain))
      .length > 0
  );
};
